import React, { useState, createContext } from 'react';

export const LumpSection = createContext();

const LumpContextProvider = (props) => {
    const [lumpPage, setLumpPage] = useState({ firstPage: true, lumpRgb: false, lumpTime: false });

    const ShowHideLumpFunction = (page) => {
        switch (page) {
            case "firstPage":
                setLumpPage({ firstPage: true, lumpRgb: false, lumpTime: false })
                break;
            case "lumpRgb":
                setLumpPage({ firstPage: false, lumpRgb: true, lumpTime: false })
                break;
            case "lumpTime":
                setLumpPage({ firstPage: false, lumpRgb: false, lumpTime: true })
                break;
        }
    }

    return (
        <>
            <LumpSection.Provider value={{ lumpPage, ShowHideLumpFunction }}>
                {props.children}
            </LumpSection.Provider>
        </>
    );
};

export { LumpContextProvider };